// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"node_modules_stencil_core_internal_client_shadow-css_js":"ca56a05d","vendors-node_modules_dayjs_plugin_utc_js-node_modules_draft-js_lib_Draft_js-node_modules_fast-0a89c8":"1aed73a1","src_pages_applications_view_ApplicationViewPage_tsx":"ec24baf6"}[chunkId] + ".chunk.js";
};